import { ModalManagerService } from './modal-manager.service';

export const providers = [ModalManagerService];
